export const DELETE_EMPLOYEE_FAILURE = 'DELETE_EMPLOYEE_FAILURE';

export const deleteEmployeeFailure = error => ({
    type: DELETE_EMPLOYEE_FAILURE,
    payload: error,
    error: true,
});
